import { StyledModal } from '@app/components/modal/Modal';
import useAgentActions from '@app/hooks/agents/useAgentActions';
import type { AIAgent } from '@app/services/api.types';
import type { ModalProps } from 'antd';
import { AgentForm, type AgentFormValues } from './AgentForm';
import useAgent from '@app/hooks/agents/useAgent';

export type AgentEditModalProps = ModalProps & {
    title?: string;
    data?: AIAgent;
};

export const AgentEditModal = ({
    title = 'Edit AI Agent',
    data,
    onOk,
    ...props
}: AgentEditModalProps) => {
    const { editAgent } = useAgentActions();
    const { data: agentData } = useAgent(
        { id: data?.id || '' },
        {
            enabled: Boolean(data?.id),
        }
    );

    // Reset the component if closed
    if (!props.open) {
        return null;
    }

    const handleSubmit = (values: AgentFormValues) => {
        if (data) {
            const formData = { ...values, id: data.id };
            editAgent.mutate(formData, {
                onSuccess: () => {
                    if (onOk) {
                        onOk(undefined as unknown as React.MouseEvent<HTMLButtonElement>);
                    }
                },
            });
        }
    };

    return (
        <StyledModal title={title} width={680} footer={null} {...props}>
            <AgentForm
                id="ai-agent-edit"
                data={{ ...data, prompt: agentData?.prompt }}
                onCancel={props.onCancel}
                loading={editAgent.isPending}
                onSubmit={handleSubmit}
            />
        </StyledModal>
    );
};
